export function getStats(array) {
 const totalItems = array.length
 const totalCash = array.reduce((acumulador, objeto) => {
  return acumulador + objeto.total;
 }, 0)

  return {totalItems, totalCash}
}
